import { render, staticRenderFns } from "./AreasListagem.vue?vue&type=template&id=3538012a&scoped=true&"
import script from "./AreasListagem.vue?vue&type=script&lang=js&"
export * from "./AreasListagem.vue?vue&type=script&lang=js&"
import style0 from "./AreasListagem.vue?vue&type=style&index=0&id=3538012a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538012a",
  null
  
)

export default component.exports